export const RESET_REG_FLOW = 'reset_reg_flow';
export const SET_BASIC_INFO = 'submit_customer_info';
export const SET_ADDRESS = 'submit_customer_address';
export const SET_PHONE_NUMBER = 'submit_phone_number';
export const SET_IMAGE_INFO = 'submit_id_images';
export const SET_RETURN_TO = 'set_return_to_store';
